import React from "react";
import { Box, Grid, Paper } from "@mui/material";
import styled from "styled-components";
import Div from "../../components/div";
import ShowWithSkeleton from "../../utils/show-with-skeleton";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0px;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0px;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const H3 = styled.h3`
    font-size: 12px;
    font-weight: 200;
    margin: 12px;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const PendingInviteCard = ({ invitesApi }) => {
    // TODO fix skeleton width and position
    const renderPendingInvites = () => {
        if (!invitesApi.data) return null;
        const pendingInvites = invitesApi.data.filter((invite) => !invite.accepted);
        if (pendingInvites.length === 0) return <H3>There are no invites pending</H3>;
        return pendingInvites.map((pendingInvite) => <H3>{pendingInvite.email}</H3>);
    };

    return (
        <Paper style={{ width: "100%", maxWidth: "850px", height: "auto", borderRadius: "14px" }}>
            <Box my={3} mx={4} pb={3}>
                <Grid>
                    <Grid container spacing={3} direction="column">
                        <Grid item>
                            <Div>
                                <H1>Pending Invites</H1>
                                <H2>Users that you have already invited to the platform</H2>
                            </Div>
                        </Grid>
                        <ShowWithSkeleton fetchAction={invitesApi}>
                            <Div style={{ padding: "1.5rem", width: "100%" }}>
                                {renderPendingInvites()}
                            </Div>
                        </ShowWithSkeleton>
                        <Grid />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default PendingInviteCard;
